module.exports = __webpack_public_path__ + "img/arrow_right.351a6f0d.svg";